import { CommissionTypes } from '@urbanx/agx.ui-components2';

export enum EditCommissionModalPage {
  Reason = 'Reason',
  Details = 'Details',
  UpdateSuccess = 'UpdateSuccess',
}

export const allowedCommissionTypes = [
  CommissionTypes.Flat,
  CommissionTypes.Tiered,
  CommissionTypes.VendorChoice,
];
